import { hotVideos } from "@/mocks/home";

export default function HotVideosSection() {
  return (
    <section id="hot" className="w-full border-b border-background-200/70 bg-background-100/60">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-14 md:px-8 md:py-20">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-label text-xs font-medium uppercase tracking-[0.3em] text-primary-600">
              Trending
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
              热门短视频，正在被反复点开
            </h2>
            <p className="mt-3 max-w-xl font-body text-sm leading-7 text-foreground-600 md:text-base">
              按近期播放与完播综合排序，封面一眼就能看出值不值得点。
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <span className="flex items-center gap-1.5 rounded-full border border-background-300/70 bg-background-50 px-3 py-1.5 font-label text-xs text-foreground-600">
              <i className="ri-fire-line text-base text-accent-600"></i>
              本周热度榜
            </span>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {hotVideos.map((video) => (
            <article
              key={video.id}
              className="group cursor-pointer overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-colors duration-300 hover:border-primary-200"
            >
              <div className="relative h-48 w-full overflow-hidden md:h-52">
                <img
                  src={video.image}
                  alt={`${video.category} 热门短视频 - ${video.title}`}
                  title={`糖豆视频 ${video.title}`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-foreground-950/10 transition-colors duration-300 group-hover:bg-foreground-950/25"></div>
                <span className="absolute left-1/2 top-1/2 flex h-12 w-12 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-background-50/90 text-primary-600 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <i className="ri-play-fill text-2xl"></i>
                </span>
                <span className="absolute bottom-3 right-3 rounded-md bg-foreground-950/70 px-2 py-0.5 font-label text-xs text-background-50">
                  {video.duration}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <span className="font-label text-xs text-secondary-700">{video.category}</span>
                <h3 className="mt-1.5 line-clamp-1 font-heading text-base font-bold text-foreground-950 md:text-lg">
                  {video.title}
                </h3>
                <div className="mt-3 flex items-center justify-between font-label text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line text-sm"></i>
                    {video.views} 次播放
                  </span>
                  <span className="flex items-center gap-1 text-primary-600">
                    <i className="ri-add-circle-line text-sm"></i>
                    加入合集
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}